export default __webpack_public_path__ + "static/example-960718533436dec731e19df35fb6e809.mp3";